module.exports = __webpack_public_path__ + "img/navigationalAidsLightBuoy.d2ae175e.svg";